import uuidv4 from 'uuid/v4';
import {deleteScreenShot, uploadScreenShot} from "../../services/apollo/screenshots";

export default {
  namespaced: true,
  actions: {
    uploadScreenshot({commit}, {image, callSid}) {
      let id = uuidv4();
      commit('setUploadingScreenshot', {id, image, callSid})
      uploadScreenShot(image, callSid)
        .then(screenshot => {
          commit('setUploadedScreenshot',  {id, callSid})
        })
    },
    deleteScreenshot({commit}, {id, sessionId}) {
      return deleteScreenShot(id)
        .then(() => {
          commit('sessions/deleteScreenshot', {id, sessionId}, {root: true})
        })
    }
  },

  mutations: {
    setUploadingScreenshot(state, {id, image, callSid}) {
      state.activeUploads = {
        ...state.activeUploads,
        [callSid]: [...(state.activeUploads[callSid] || []), {
          id,
          image,
          status: 'UPLOADING'
        }]
      }
    },
    setUploadedScreenshot(state, {id, callSid}) {
      state.activeUploads = {
        ...state.activeUploads,
        [callSid]: (state.activeUploads[callSid] || [])
          .map(screenshot => screenshot.id === id ? {
            ...screenshot,
            status: 'FINISHED'
          }: screenshot)
      }
    }
  },

  getters: {
    activeCallScreenshots: (state) => (callSid) => state.activeUploads[callSid]
  },

  state: {
    activeUploads: {

    }
  }
}
